// @flow

export function formatStepSize (value: number, stepSize: number): number {
  const stepSizeString = stepSize.toString()
  if (stepSizeString.indexOf('.') === -1) {
    return value - (value % stepSize)
  }
  const decimalPlaces = stepSizeString.split('.').pop().length
  return +(value.toFixed(decimalPlaces))
}

export function isDivisible (dividend: number, divisor: number): boolean {
  return (dividend / divisor) % 1 === 0
}
